import { request } from './client';

export const adminService = {
  // --- Categories ---
  getCategoryList: () => request('/categories'), // Public
  getCategories: () => request('/admin/categories'), // Admin
  addCategory: (name) => request('/admin/categories', { method: 'POST', body: { name } }),
  updateCategory: (id, name) => request(`/admin/categories/${id}`, { method: 'PUT', body: { name } }),
  deleteCategory: (id) => request(`/admin/categories/${id}`, { method: 'DELETE' }),

  // --- Roles ---
  getRoles: () => request('/roles'),

  // --- Devices ---
  getDevices: () => request('/auth/devices'),
  updateDevice: (id, deviceName) => request(`/auth/devices/${id}`, { method: 'PUT', body: { device_name: deviceName } }),
  deleteDevice: (id) => request(`/auth/devices/${id}`, { method: 'DELETE' }),

  // --- Email Settings ---
  getEmailSettings: () => request('/settings/email'),
  updateEmailSettings: (config) => request('/settings/email', { method: 'POST', body: config }),
  testEmailConnection: (config) => request('/settings/email/test', { method: 'POST', body: config }),

  // --- Activity Logs ---
  getActivityLogs: async () => {
    try {
      const logs = await request('/activity-logs');
      return logs.map(log => ({
        id: log.id,
        type: log.action_type,
        user: log.username,
        description: log.description,
        timestamp: new Date(log.created_at),
        // ADD THIS LINE:
        ip_address: log.ip_address 
      }));
    } catch (error) {
      console.error("Error fetching activity logs:", error);
      return [];
    }
  },
  cleanupSessions: () => request('/auth/devices/cleanup', { method: 'POST' }),
  
};
